export default "/_next/static/c1be8e90c41558d4e92be87de2e47066.png";